import { authorizeInstance } from 'src/configs/axios.config';
import { AXIOS_SILENT_ALL } from "src/constants";

const MODULE = "authorize";

export const login = (data, configs = {}) => authorizeInstance.post(`/v1/${MODULE}/password`, data, { ...configs, silent: [AXIOS_SILENT_ALL] });

export const logout = (configs = {}) => authorizeInstance.post(`/v1/${MODULE}/logout`, undefined, configs);

export const getNewToken = (configs = {}) => authorizeInstance.post(`/v1/${MODULE}/refresh_token`, undefined, configs);